/**
 *   Created by Arif Topcu in 2018
 */
import React, { useCallback } from "react";
import Combobox from "@ls/react-combobox-grid";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import {
  selectAllEntities,
  selectBenchmarkEntityId,
  selectFetchingEntities,
} from "state/selections/selector";
import { setBenchmarkEntityId } from "state/selections/actions";

const columnDefs = [
  {
    headerName: "Entity ID",
    field: "entityId",
    width: 75,
    suppressSizeToFit: true,
  },
  {
    headerName: "Entity",
    field: "label",
  },
];

const EntitySelector = (props) => {
  const dispatch = useDispatch();
  const entities = useSelector(selectAllEntities);
  const fetchingEntities = useSelector(selectFetchingEntities);
  const selectedBenchmarkEntityId = useSelector(
    selectBenchmarkEntityId(SelectionState.UNCOMMITTED)
  );
  const onChange = useCallback(
    (values) => {
      dispatch(setBenchmarkEntityId(values));
    },
    [dispatch]
  );

  return (
    <Combobox
      options={entities}
      onChange={onChange}
      value={selectedBenchmarkEntityId}
      loading={fetchingEntities}
      tooltip="(Optional) Select an entity to enforce as a benchmark for all accounts."
      placeholder="Entities..."
      label="Use Single Benchmark:"
      valueKey="entityId"
      labelKey="label"
      columnDefs={columnDefs}
      variation={1}
    />
  );
};

export default EntitySelector;
